import React from 'react';

export default function ({ children, title, active, className }) {
  if (title !== active) { return null; }
  return <div className={className}>{children}</div>;
}
